/**
 * Plate families: how unusual a *type* of plate is, independent of which state
 * issued it. Combined with a jurisdiction weight this yields every point value
 * in the catalogue, so balancing the whole game lives in these two tables.
 */

export type Family =
  | 'standard'
  | 'slogan'
  | 'superseded'
  | 'custom'
  | 'euro'
  | 'slimline'
  | 'motorcycle'
  | 'trailer'
  | 'heavy'
  | 'bus'
  | 'taxi'
  | 'government'
  | 'emergency'
  | 'ev'
  | 'dealer'
  | 'club'
  | 'primaryProducer'
  | 'viceregal'
  | 'oneOff';

export interface FamilyDef {
  key: Family;
  label: string;
  /** Base points before the jurisdiction multiplier. Ignored for `oneOff`. */
  base: number;
  /** Suffix appended to the jurisdiction name to build a default plate name. */
  nameSuffix: string;
}

export const FAMILIES: Record<Family, FamilyDef> = {
  standard:        { key: 'standard',        label: 'Standard issue',   base: 25,  nameSuffix: 'standard' },
  slogan:          { key: 'slogan',          label: 'Slogan variant',   base: 40,  nameSuffix: 'slogan' },
  custom:          { key: 'custom',          label: 'Personalised',     base: 40,  nameSuffix: 'personalised' },
  euro:            { key: 'euro',            label: 'Euro style',       base: 90,  nameSuffix: 'Euro plate' },
  slimline:        { key: 'slimline',        label: 'Slimline',         base: 70,  nameSuffix: 'slimline plate' },
  motorcycle:      { key: 'motorcycle',      label: 'Motorcycle',       base: 60,  nameSuffix: 'motorcycle' },
  trailer:         { key: 'trailer',         label: 'Trailer',          base: 60,  nameSuffix: 'trailer' },
  heavy:           { key: 'heavy',           label: 'Heavy vehicle',    base: 60,  nameSuffix: 'heavy vehicle' },
  bus:             { key: 'bus',             label: 'Bus / coach',      base: 120, nameSuffix: 'bus' },
  taxi:            { key: 'taxi',            label: 'Taxi / hire car',  base: 120, nameSuffix: 'taxi' },
  government:      { key: 'government',      label: 'Government fleet', base: 150, nameSuffix: 'government' },
  superseded:      { key: 'superseded',      label: 'Superseded issue', base: 150, nameSuffix: 'superseded issue' },
  emergency:       { key: 'emergency',       label: 'Emergency services', base: 170, nameSuffix: 'emergency services' },
  ev:              { key: 'ev',              label: 'Electric vehicle', base: 180, nameSuffix: 'EV' },
  dealer:          { key: 'dealer',          label: 'Dealer / trade',   base: 200, nameSuffix: 'dealer' },
  club:            { key: 'club',            label: 'Club / historic',  base: 200, nameSuffix: 'club permit' },
  primaryProducer: { key: 'primaryProducer', label: 'Primary producer', base: 250, nameSuffix: 'primary producer' },
  viceregal:       { key: 'viceregal',       label: 'Vice-regal',       base: 300, nameSuffix: 'Governor' },
  oneOff:          { key: 'oneOff',          label: 'Special',          base: 0,   nameSuffix: '' },
};

export const FAMILY_ORDER: Family[] = [
  'standard', 'slogan', 'custom', 'euro', 'slimline', 'motorcycle', 'trailer', 'heavy', 'bus',
  'taxi', 'government', 'superseded', 'emergency', 'ev', 'dealer', 'club',
  'primaryProducer', 'viceregal', 'oneOff',
];
